import { getFreeVideos, incrementFreeVideosUsage } from '@/services/api';
import { useAuth } from '@/services/auth';
import { PlanGroup } from '@d-id/types';
import { useMutation, useQuery } from 'react-query';

export const useFreeVideos = () => {
    const { user } = useAuth();

    const enabled = !!user && user.planGroup === PlanGroup.FREE;

    const incrementUsage = useMutation((count: number) => {
        if (!enabled) {
            return Promise.resolve();
        }

        return incrementFreeVideosUsage({ count });
    });

    const query = useQuery('free-videos', getFreeVideos, {
        enabled,
    });

    const outOfFreeVideos = query.data?.remaining === 0 && enabled;

    return { ...query, incrementUsage, enabled, outOfFreeVideos };
};
